export default function ColouredCursor({ className }) {
  return (
    <img src="/assets/images/coloured-icons/cursor.png" className={className} />
  );
}
